export const MERAKI_STACK_COLUMNS = ['serial', 'stack_name', 'mac_address'];

export const STACK_AVAILABILITY_COLUMNS = ['uptime', 'available_power'];
